module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper",
    style: ({
      minHeight: _vm.minHeight + 'px'
    })
  }, [_vm._m(0), _vm._v(" "), _c('BottomBar', {
    attrs: {
      "index": 2
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "label special"
  }, [_vm._v("\n                修改头像\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_c('div', {
    staticClass: "avatar",
    attrs: {
      "src": "",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n                昵称\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("\n                afdasdfasdfadsf\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n                手机\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("\n                1111111111111111123\n            ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c8b2f532!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/profile-edit.vue
// module id = 246
// module chunks = 1